<template>
	<Modal
		title="VINCULAR MOTORISTA"
		@close="close"
	>
		<div class="input-wrapper">
			<div class="row">
				<div class="col-xs-12 col-lg-9">
					<FormInputMasked v-model="input" label="CPF do motorista cadastrado pelo APP" type="tel" icon="fa-search" mask="###.###.###-##" tooltip="Informe o CPF do motorista já cadastrado no APP DeliveryB2B" />
				</div>
				<div class="col-xs-12 col-lg-3">
					<button class="search-submit" @click="search">
						<i v-if="!loading" class="fa fa-fw fa-search"></i> 
						<i v-if="loading" class="fa fa-fw fa-circle-notch fa-spin"></i> 
						BUSCAR
					</button>
				</div>
			</div>

			<div class="search-result" v-if="results.length">
				<h4>Motorista encontrado: </h4>

				<div class="profile-card shadowed" v-for="(result, idx) in results" :key="idx">
					<div class="profile-picture">
						<img :src="require('@/assets/user.png')" >
					</div>
					<div class="profile-info">
						<div class="profile-name">
							{{ result.name }}
							<button class="add-driver-submit" @click="add_driver(result)">
								<i class="fa fa-plus"></i> VINCULAR
							</button>
						</div>
						<div class="profile-document">
							<i class="fa fa-fw fa-address-card"></i> {{ result.document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") }}
						</div>
						<div class="profile-contact">
							<i class="fa fa-fw fa-envelope"></i> {{ result.email }} | <i class="fa fa-fw fa-phone"></i> {{ result.phone.replace(/^(\d{2})(\d{2})(\d{5})(\d{4})/, "+$1 $2 $3-$4") }}
						</div>
						<div class="profile-nickname">
							<p class="label-nickname">Identificador <span v-popover:tooltip.right="'Informe um identificador personalizado para ser exibido no mapa de rastreio'"><i class="fas fa-question-circle"></i></span></p>
							<input v-model="result.nickname" class="input-nickname" type="text" placeholder="Insira o identificador" />
						</div>
					</div>
				</div>

			</div>

		</div>
		
	</Modal>
</template>

<script>
import Api from "@/lib/Api";

import Modal from "@/components/Modal";
import FormInputMasked from "@/components/FormInputMasked";

export default {
	name: "DriverSearch",

	components: {
		FormInputMasked,
		Modal,
	},

	data: function() {
		return {
			loading: false,
			input: '',
			results: [],
		}
	},

	methods: {
		search: async function() {
			let form = {};
			let result = null;

			form.document = this.input.trim();
			if (!form.document) return;

			this.results = [];

			this.loading = true;
			try {
				result = await Api.post("driver/search-driver", form);
			} catch(ex) {
				console.log(ex);
				this.loading = false;
				this.$notification.error("Não foi possível buscar os registros");
				return;
			}
			this.loading = false;

			if (result) {
				if (result.error) {
					this.$notification.error(result.data);
					return;
				}

				if (result.data.length == 0) {
					this.$notification.error("Nenhum registro encontrado.");
					return;
				}

				this.results = result.data;
				
				this.results.forEach(element => {
					element.nickname = element.name.split(" ")[0];
				});
				return;
			} else {
				this.$notification.error("Não foi possível obter os registros.");
				return;
			}
		},

		add_driver: async function(driver) {
			if (!driver.nickname) {
				this.$notification.error("Identificador inválido.");
				return;
			}

			let confirm = await this.$alert.confirm("Este motorista poderá buscar cargas da sua empresa utilizando os dados de placa e data.", "VINCULAR MOTORISTA?");
			if (!confirm) return;

			let form = {};
			let result = null;

			form.id = driver.id;
			form.nickname = driver.nickname;

			this.loading = true;
			try {
				result = await Api.post("driver/add-driver", form);
			} catch(ex) {
				console.log(ex);
				this.loading = false;
				this.$notification.error("Não foi possível vincular este motorista.");
				return;
			}
			this.loading = false;

			if (result) {
				if (result.error) {
					this.$notification.error(result.data);
				}
				
				this.$notification.success("Motorista vinculado com sucesso.");
				this.$parent.load();
				this.close();
				return;
			} else {
				this.$notification.error("Não foi possível vincular este motorista.");
				return;
			}
		},

		/**
		 * Fecha o modal
		 **/ 
		close: function() {
			this.$emit("close");
		},
	}
}
</script>

<style scoped>
.input-wrapper {
	position: relative;
}

.search-submit {
	background: #222;
	position: absolute;
	top: 20px;
	right: 0;
	height: 40px;
	line-height: 40px;
	border: none;
	padding: 0 15px;
	font-weight: bold;
	color: #fff;
}


.search-result {
	width: 100%;
}







.profile-card {
	width: 100%;
	background-color: #eee;
	padding: 10px;
	border-radius: 4px;
	float: left;
}

.profile-picture {
    width: 80px;
    height: 80px;
    float: left;
}

.profile-picture > img {
	width: 100%;
	height: 100%;
	background: #fff;
	border-radius: 100%;
}

.profile-info {
    float: left;
    width: calc(100% - 80px);
    padding: 10px;
}

.profile-name {
	position: relative;
    font-size: 18px;
    font-weight: bold;
}

.profile-document {
    font-size: 14px;
    font-weight: bold;
    padding: 5px 0;
}

.profile-contact {
    font-size: 12px;
    font-style: italic;
}

.profile-contact {
    margin-bottom: 20px;
}





.add-driver-submit {
	background: #222;
	border: none;
	padding: 10px 15px;
	color: #fff;
	font-weight: bold;
	position: absolute;
	right: -5px;
	top: -5px;
	font-size: 12px;
}

.label-nickname {
	font-size: 14px;
	margin-block-start: 0px;
	margin-block-end: 5px;
}

.input-nickname {
	background-color: #fff;
	height: 31px;
	padding: 3px 7px;
	line-height: normal;
	border: 1px solid #888C8C;
	border-radius: 3px;
	box-shadow: 0 1px 2px rgba(15,17,17,.15) inset;
	outline: 0;
}

</style>